import { initialBetMultipleState, IBetMultipleState } from '../state/betmultiple.state';
import { BetMultipleActions, EBetMultipleActions } from '../actions/betmultiple.actions';

export const betMultipleReducers = (
  state = initialBetMultipleState,
  action: BetMultipleActions
): IBetMultipleState => {
  switch (action.type) {
    case EBetMultipleActions.AddBetMultiple: {
      return {
        ...state,
        betmultiple: action.payload
      };
    }
    case EBetMultipleActions.DelBetMultiple: {
      return {
        ...state,
        betmultiple: null
      };
    }

    default:
      return state;
  }
};
